module.exports = __webpack_public_path__ + "static/media/recordista_b.ebb4389c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/recordista_b.png
// module id = 1172
// module chunks = 0